module.exports = __webpack_public_path__ + "static/media/619MeldrumStNW_2018-06-18_115.9f12f088.jpg";